import { CKBox, CKCheckbox } from '@clearkit/react';

import { usePlatformAccess } from '~/hooks/account/usePlatformAccess';

export default function UpgradePlanItem({
  name,
  title,
  description,
  values,
  onChange,
  className,
  addon,
}) {
  const checked = values[name];
  const platformAccess = usePlatformAccess();
  const disabled = platformAccess[addon];

  return (
    <CKBox
      key={name}
      className={classnames('px-4 pt-2', className, {
        'bg-blue-0 border-blue-200': checked && !disabled,
        'bg-gray-0 border-gray-200': disabled,
      })}>
      <CKCheckbox
        id={`upgrade-plan-${name}`}
        name={name}
        label={
          <div className="m-2">
            <div className="text-base font-medium">{title}</div>
            <div className="">{description}</div>
          </div>
        }
        disabled={disabled}
        checked={checked || disabled}
        onChange={(event) => onChange(name, event.target.checked)}
      />
    </CKBox>
  );
}
